'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ShowHide = require('./ShowHide');

var _FadeIn = require('./FadeIn');

var _EventListener40 = require('./EventListener');

var _EventListener41 = _interopRequireDefault(_EventListener40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = {
  // Show and hide
  show: _ShowHide.Show,
  hide: _ShowHide.Hide,

  // Fade in
  fadeIn: _FadeIn.FadeIn,

  // Event listeners

  onclick: function (_EventListener) {
    _inherits(onclick, _EventListener);

    function onclick() {
      _classCallCheck(this, onclick);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onclick).call(this, 'click'));
    }

    return onclick;
  }(_EventListener41.default),
  oncontextmenu: function (_EventListener2) {
    _inherits(oncontextmenu, _EventListener2);

    function oncontextmenu() {
      _classCallCheck(this, oncontextmenu);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(oncontextmenu).call(this, 'contextmenu'));
    }

    return oncontextmenu;
  }(_EventListener41.default),
  ondblclick: function (_EventListener3) {
    _inherits(ondblclick, _EventListener3);

    function ondblclick() {
      _classCallCheck(this, ondblclick);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondblclick).call(this, 'dblclick'));
    }

    return ondblclick;
  }(_EventListener41.default),
  onmousedown: function (_EventListener4) {
    _inherits(onmousedown, _EventListener4);

    function onmousedown() {
      _classCallCheck(this, onmousedown);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmousedown).call(this, 'mousedown'));
    }

    return onmousedown;
  }(_EventListener41.default),
  onmouseenter: function (_EventListener5) {
    _inherits(onmouseenter, _EventListener5);

    function onmouseenter() {
      _classCallCheck(this, onmouseenter);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmouseenter).call(this, 'mouseenter'));
    }

    return onmouseenter;
  }(_EventListener41.default),
  onmouseleave: function (_EventListener6) {
    _inherits(onmouseleave, _EventListener6);

    function onmouseleave() {
      _classCallCheck(this, onmouseleave);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmouseleave).call(this, 'mouseleave'));
    }

    return onmouseleave;
  }(_EventListener41.default),
  onmousemove: function (_EventListener7) {
    _inherits(onmousemove, _EventListener7);

    function onmousemove() {
      _classCallCheck(this, onmousemove);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmousemove).call(this, 'mousemove'));
    }

    return onmousemove;
  }(_EventListener41.default),
  onmouseover: function (_EventListener8) {
    _inherits(onmouseover, _EventListener8);

    function onmouseover() {
      _classCallCheck(this, onmouseover);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmouseover).call(this, 'mouseover'));
    }

    return onmouseover;
  }(_EventListener41.default),
  onmouseout: function (_EventListener9) {
    _inherits(onmouseout, _EventListener9);

    function onmouseout() {
      _classCallCheck(this, onmouseout);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmouseout).call(this, 'mouseout'));
    }

    return onmouseout;
  }(_EventListener41.default),
  onmouseup: function (_EventListener10) {
    _inherits(onmouseup, _EventListener10);

    function onmouseup() {
      _classCallCheck(this, onmouseup);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmouseup).call(this, 'mouseup'));
    }

    return onmouseup;
  }(_EventListener41.default),
  onkeydown: function (_EventListener11) {
    _inherits(onkeydown, _EventListener11);

    function onkeydown() {
      _classCallCheck(this, onkeydown);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onkeydown).call(this, 'keydown'));
    }

    return onkeydown;
  }(_EventListener41.default),
  onkeypress: function (_EventListener12) {
    _inherits(onkeypress, _EventListener12);

    function onkeypress() {
      _classCallCheck(this, onkeypress);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onkeypress).call(this, 'keypress'));
    }

    return onkeypress;
  }(_EventListener41.default),
  onkeyup: function (_EventListener13) {
    _inherits(onkeyup, _EventListener13);

    function onkeyup() {
      _classCallCheck(this, onkeyup);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onkeyup).call(this, 'keyup'));
    }

    return onkeyup;
  }(_EventListener41.default),
  onload: function (_EventListener14) {
    _inherits(onload, _EventListener14);

    function onload() {
      _classCallCheck(this, onload);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onload).call(this, 'load'));
    }

    return onload;
  }(_EventListener41.default),
  onresize: function (_EventListener15) {
    _inherits(onresize, _EventListener15);

    function onresize() {
      _classCallCheck(this, onresize);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onresize).call(this, 'resize'));
    }

    return onresize;
  }(_EventListener41.default),
  onscroll: function (_EventListener16) {
    _inherits(onscroll, _EventListener16);

    function onscroll() {
      _classCallCheck(this, onscroll);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onscroll).call(this, 'scroll'));
    }

    return onscroll;
  }(_EventListener41.default),
  onblur: function (_EventListener17) {
    _inherits(onblur, _EventListener17);

    function onblur() {
      _classCallCheck(this, onblur);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onblur).call(this, 'blur'));
    }

    return onblur;
  }(_EventListener41.default),
  onchange: function (_EventListener18) {
    _inherits(onchange, _EventListener18);

    function onchange() {
      _classCallCheck(this, onchange);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onchange).call(this, 'change'));
    }

    return onchange;
  }(_EventListener41.default),
  onfocus: function (_EventListener19) {
    _inherits(onfocus, _EventListener19);

    function onfocus() {
      _classCallCheck(this, onfocus);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onfocus).call(this, 'focus'));
    }

    return onfocus;
  }(_EventListener41.default),
  onfocusin: function (_EventListener20) {
    _inherits(onfocusin, _EventListener20);

    function onfocusin() {
      _classCallCheck(this, onfocusin);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onfocusin).call(this, 'focusin'));
    }

    return onfocusin;
  }(_EventListener41.default),
  onfocusout: function (_EventListener21) {
    _inherits(onfocusout, _EventListener21);

    function onfocusout() {
      _classCallCheck(this, onfocusout);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onfocusout).call(this, 'focusout'));
    }

    return onfocusout;
  }(_EventListener41.default),
  oninput: function (_EventListener22) {
    _inherits(oninput, _EventListener22);

    function oninput() {
      _classCallCheck(this, oninput);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(oninput).call(this, 'input'));
    }

    return oninput;
  }(_EventListener41.default),
  onreset: function (_EventListener23) {
    _inherits(onreset, _EventListener23);

    function onreset() {
      _classCallCheck(this, onreset);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onreset).call(this, 'reset'));
    }

    return onreset;
  }(_EventListener41.default),
  onselect: function (_EventListener24) {
    _inherits(onselect, _EventListener24);

    function onselect() {
      _classCallCheck(this, onselect);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onselect).call(this, 'select'));
    }

    return onselect;
  }(_EventListener41.default),
  onsubmit: function (_EventListener25) {
    _inherits(onsubmit, _EventListener25);

    function onsubmit() {
      _classCallCheck(this, onsubmit);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onsubmit).call(this, 'submit'));
    }

    return onsubmit;
  }(_EventListener41.default),
  ondrag: function (_EventListener26) {
    _inherits(ondrag, _EventListener26);

    function ondrag() {
      _classCallCheck(this, ondrag);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondrag).call(this, 'drag'));
    }

    return ondrag;
  }(_EventListener41.default),
  ondragend: function (_EventListener27) {
    _inherits(ondragend, _EventListener27);

    function ondragend() {
      _classCallCheck(this, ondragend);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondragend).call(this, 'dragend'));
    }

    return ondragend;
  }(_EventListener41.default),
  ondragenter: function (_EventListener28) {
    _inherits(ondragenter, _EventListener28);

    function ondragenter() {
      _classCallCheck(this, ondragenter);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondragenter).call(this, 'dragenter'));
    }

    return ondragenter;
  }(_EventListener41.default),
  ondragleave: function (_EventListener29) {
    _inherits(ondragleave, _EventListener29);

    function ondragleave() {
      _classCallCheck(this, ondragleave);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondragleave).call(this, 'dragleave'));
    }

    return ondragleave;
  }(_EventListener41.default),
  ondragover: function (_EventListener30) {
    _inherits(ondragover, _EventListener30);

    function ondragover() {
      _classCallCheck(this, ondragover);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondragover).call(this, 'dragover'));
    }

    return ondragover;
  }(_EventListener41.default),
  ondragstart: function (_EventListener31) {
    _inherits(ondragstart, _EventListener31);

    function ondragstart() {
      _classCallCheck(this, ondragstart);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondragstart).call(this, 'dragstart'));
    }

    return ondragstart;
  }(_EventListener41.default),
  ondrop: function (_EventListener32) {
    _inherits(ondrop, _EventListener32);

    function ondrop() {
      _classCallCheck(this, ondrop);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(ondrop).call(this, 'drop'));
    }

    return ondrop;
  }(_EventListener41.default),
  animationend: function (_EventListener33) {
    _inherits(animationend, _EventListener33);

    function animationend() {
      _classCallCheck(this, animationend);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(animationend).call(this, 'animationend'));
    }

    return animationend;
  }(_EventListener41.default),
  animationiteration: function (_EventListener34) {
    _inherits(animationiteration, _EventListener34);

    function animationiteration() {
      _classCallCheck(this, animationiteration);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(animationiteration).call(this, 'animationiteration'));
    }

    return animationiteration;
  }(_EventListener41.default),
  animationstart: function (_EventListener35) {
    _inherits(animationstart, _EventListener35);

    function animationstart() {
      _classCallCheck(this, animationstart);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(animationstart).call(this, 'animationstart'));
    }

    return animationstart;
  }(_EventListener41.default),
  transitionend: function (_EventListener36) {
    _inherits(transitionend, _EventListener36);

    function transitionend() {
      _classCallCheck(this, transitionend);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(transitionend).call(this, 'webkitTransitionEnd'));
    }

    return transitionend;
  }(_EventListener41.default),
  onmessage: function (_EventListener37) {
    _inherits(onmessage, _EventListener37);

    function onmessage() {
      _classCallCheck(this, onmessage);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onmessage).call(this, 'message'));
    }

    return onmessage;
  }(_EventListener41.default),
  onopen: function (_EventListener38) {
    _inherits(onopen, _EventListener38);

    function onopen() {
      _classCallCheck(this, onopen);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onopen).call(this, 'open'));
    }

    return onopen;
  }(_EventListener41.default),
  onwheel: function (_EventListener39) {
    _inherits(onwheel, _EventListener39);

    function onwheel() {
      _classCallCheck(this, onwheel);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(onwheel).call(this, 'wheel'));
    }

    return onwheel;
  }(_EventListener41.default)
};

"use strict";